export enum ItemProtectionBenefitType {
  LOSS = "Loss",
  THEFT = "Theft",
  DAMAGE = "Damage",
  ACCIDENTAL_DAMAGE = "AccidentalDamage",
  WATER_DAMAGE = "WaterDamage",
  FIRE_DAMAGE = "FireDamage",
  REPLACEMENT_COST = "ReplacementCost",
  WORLDWIDE_COVER = "WorldwideCover",
  BUSINESS_USE = "BusinessUse"
}
